import { useCallback, useMemo } from 'react';
// eslint-disable-next-line max-len
import { useDeleteVariantConfiguratorTrimSettingAssetMutation, VariantConfiguratorAsset } from '../../../../api';
// eslint-disable-next-line max-len
import { useUploadVariantConfiguratorTrimSettingAssetMutation } from '../../../../api/mutations/uploadVariantConfiguratorTrimSettingAsset';

const useHandleTrimSettingAsset = () => {
    const [uploadTrimSettingAssetMutation] = useUploadVariantConfiguratorTrimSettingAssetMutation();
    const [deleteTrimSettingAssetMutation] = useDeleteVariantConfiguratorTrimSettingAssetMutation();

    const uploadTrimSettingAsset = useCallback(
        async (variantConfiguratorId: string, blockId: string, trimSettingId: string, upload: File) => {
            const { data } = await uploadTrimSettingAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    blockId,
                    trimSettingId,
                    type: VariantConfiguratorAsset.TrimSettingImage,
                    upload,
                },
            });

            return data?.variantConfigurator.trimBlock;
        },
        [uploadTrimSettingAssetMutation]
    );

    const deleteTrimSettingAsset = useCallback(
        async (variantConfiguratorId: string, blockId: string, trimSettingId: string) => {
            const { data } = await deleteTrimSettingAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    blockId,
                    trimSettingId,
                    type: VariantConfiguratorAsset.TrimSettingImage,
                },
            });

            return data?.variantConfigurator.trimBlock;
        },
        [deleteTrimSettingAssetMutation]
    );

    return useMemo(
        () => ({
            uploadTrimSettingAsset,
            deleteTrimSettingAsset,
        }),
        [deleteTrimSettingAsset, uploadTrimSettingAsset]
    );
};

export default useHandleTrimSettingAsset;
